module.exports = __webpack_public_path__ + "img/control_device5.4e8082e5.png";